import styled from 'styled-components';

export const Container = styled.div`
  gap: 32px;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr 0.7fr 1fr;
`;
